import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  CardWrapper, ButtonUI, ButtonOutlined, Field,
} from '../../UI';
import { BlocoEnderecos, BlocoTelefones } from './BlocosCadastrais';
import * as C from '../../../theme/colors.constants';

/**
 * Aba Devedor — print `grid_check_devedor.png`.
 *
 * Cabeçalho com ícone + título + os botões "PESQUISA WEB SERVICE" e "ALTERAR",
 * campos de identificação, o bloco "Devedores Antecedentes" com tabela, e por
 * fim os blocos compartilhados de endereços e telefones.
 */
const ANTECEDENTES_DEVEDOR = [
  {
    codigo: '3.000.000',
    nome: 'Devedor de Testes do AB',
    nomeFantasia: 'Nome Fantasia do Deve',
    cpfCnpj: '48.780.319/0001-03',
    cidade: 'São Paulo',
    estado: 'São Paulo',
  },
];

export default function AbaDevedor({ processo }) {
  return (
    <CardWrapper>
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, flexWrap: 'wrap',
      }}
      >
        <PersonOutlineIcon sx={{ color: C.navy }} />
        <Typography variant="h2" sx={{ flex: 1 }}>Dados do Devedor</Typography>
        <ButtonUI size="small">PESQUISA WEB SERVICE</ButtonUI>
        <ButtonUI size="small">ALTERAR</ButtonUI>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mb: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Ultima pesquisa:" InputProps={{ readOnly: true }} />
        <Field label="Retorno consulta:" InputProps={{ readOnly: true }} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Categoria:" tipo="select" options={['Pessoa Jurídica', 'Pessoa Física']} />
        <Field label="CPF/CNPJ" />
        <Field label="Data função:" tipo="data" />
        <Field label="Situação empresa:" tipo="select" options={['Ativa', 'Baixada', 'Suspensa']} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, 1fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Nome Fantasia:" value={processo?.nomeDevedor || ''} />
        <Field label="Código do cliente:" value="16 38777100" />
        <Field label="Inscrição estadual:" />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="CNPJ/CPF:" />
        <Field label="Código do devedor:" />
      </Box>

      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Devedores Antecedentes:</Typography>
      <Field label="Cód. Devedor principal:" sx={{ mb: 2 }} />

      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Nome Fantasia</TableCell>
              <TableCell>CPF/CNPJ</TableCell>
              <TableCell>Cidade</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ANTECEDENTES_DEVEDOR.map(d => (
              <TableRow key={d.codigo} hover>
                <TableCell sx={{ color: C.navy, fontWeight: 600 }}>{d.codigo}</TableCell>
                <TableCell>{d.nome}</TableCell>
                <TableCell>{d.nomeFantasia}</TableCell>
                <TableCell>{d.cpfCnpj}</TableCell>
                <TableCell>{d.cidade}</TableCell>
                <TableCell>{d.estado}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <BlocoEnderecos />
      <BlocoTelefones />

      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3,
      }}
      >
        <ButtonOutlined>CANCELAR</ButtonOutlined>
        <ButtonUI>GRAVAR</ButtonUI>
      </Box>
    </CardWrapper>
  );
}
AbaDevedor.propTypes = { processo: PropTypes.object };
AbaDevedor.defaultProps = { processo: null };
